<template lang="pug">
    model-form(
        loading-text='Cargando prestamo...'
        ref='form'
        reset-text='restablecer'
        submit-text='guardar'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submitUpdate'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import EmployeeLoanCompanyModel from '@/models/HumanResource/HrEmployeeLoanCompany'
    import EmployeeLoanCompanyFields from '@/views/HumanResource/HrEmployeeLoanCompany/HrEmployeeLoanCompanyFields'
    //
    export default {
        name: 'employee-loan-company-update',
        components: {
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             *
             */
            formProps() {
                return {
                    editable: false,
                    fields: EmployeeLoanCompanyFields,
                    loading: this.busy,
                    switchEdit: true,
                    title: this.formTitle,
                }
            },

            /**
             * 
             */
            formTitle() {
                return `Prestamo #${this.$route.params.id}`
            },
        },
        data() {
            return {
                busy: false,
                formData: {},
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(EmployeeLoanCompanyModel, error.response.data))
            },

            /**
             * 
             */
            fetch() {
                return EmployeeLoanCompanyModel.modeler().find(this.$route.params.id).then(this.setFormData)
            },

            /**
             * 
             */
            reset() {
                this.setBusy(true).then(this.fetch).then(this.setBusy)
            },

            /**
             * 
             */
            async setBusy(busy = false) {
                this.busy = busy
            },

            /**
             * 
             */
            setFormData(model) {
                this.formData = model.reset()
            },

            /**
             * 
             */
            submitUpdate() {
                return this.$refs.form
                    .setWait(true)
                    .then(this.toUpdate)
                    .catch(this.error)
                    .then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            successUpdate() {
                this.setSuccessSnackbar('Prestamo actualizado exitosamente.')
            },

            /**
             *
             */
            toUpdate(model) {
                return model
                    .toUpdate()
                    .save()
                    .then(this.successUpdate)
                    .then(this.reset)
            },
        },
        mounted() {
            this.setTitleTopBar('Detalle prestamo').then(this.reset)
        },
    }
</script>